<app-activity-timeslot-list
  [activity]="activity"
  [hasSeeMoreUrl]="hasSeeMoreUrl"
  [seeMoreUrl]="seeMoreUrl"
  [timeslots]="timeslots"
  [timeslotVariant]="timeslotVariant"
  [hasPagination]="hasPagination"
  [hasLoadMoreButton]="hasLoadMoreButton"
  [organizerName]="organizerName"
  (loadMore)="loadMore.emit()"
>
  <ng-container *ngFor="let timeslot of timeslots">
    <ng-container *appListItem>
      <button
        *ngIf="!timeslot.isExternal() && !isTimeslotInCart(timeslot)"
        app-vtmn-play-button
        type="button"
        cta
        class="ml-auto"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.PRIMARY"
        [size]="vtmnPlayButtonSize.SMALL"
        [disabled]="
          !timeslot.isBookable(activity?.bookableUntilTheEnd) ? true : null
        "
        [attr.data-disabled]="
          !timeslot.isBookable(activity?.bookableUntilTheEnd) ? true : null
        "
        (click)="addToCart(timeslot)"
      >
        {{ getCtaAddText() }}
      </button>
      <button
        *ngIf="!timeslot.isExternal() && isTimeslotInCart(timeslot)"
        app-vtmn-play-button
        type="button"
        cta
        class="ml-auto"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
        [size]="vtmnPlayButtonSize.SMALL"
        [disabled]="
          !timeslot.isBookable(activity?.bookableUntilTheEnd) ? true : null
        "
        [attr.data-disabled]="
          !timeslot.isBookable(activity?.bookableUntilTheEnd) ? true : null
        "
        (click)="deleteTimeslot(timeslot)"
      >
        {{ getCtaDeleteText() }}
      </button>
      <button
        *ngIf="timeslot.isExternal()"
        app-vtmn-play-button
        type="button"
        cta
        class="ml-auto"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.PRIMARY"
        [size]="vtmnPlayButtonSize.SMALL"
        (click)="redirectBookingUrl(timeslot.getBookingURL)"
      >
        {{ 'timeslot.book_external' | translate }}
      </button>
      <app-modal
        #confirmNewCartModal
        class="activity-timeslot-list__cart-modal"
        (modalClose)="closeConfirmNewCartModal()"
        data-test="new-cart"
      >
        <span modal-header class="activity-timeslot-list__cart-modal__title">
          {{ 'checkout.cart.alert.new.title' | translate }}
        </span>

        <div modal-content>
          <p>{{ newCartModalText }}</p>
        </div>
        <div modal-footer class="activity-timeslot-list__cart-modal__footer">
          <button
            class="activity-timeslot-list__cart-modal__footer__confirm"
            app-vtmn-play-button
            type="button"
            [type]="ctaButtonType.Button"
            [variant]="vtmnPlayButtonVariant.SECONDARY"
            [shape]="vtmnPlayButtonShape.SQUARED"
            (click)="closeConfirmNewCartModal()"
          >
            {{ 'checkout.cart.alert.new.cancel' | translate }}
          </button>

          <button
            app-vtmn-play-button
            type="button"
            [type]="ctaButtonType.Button"
            [variant]="vtmnPlayButtonVariant.NEGATIVE"
            [shape]="vtmnPlayButtonShape.SQUARED"
            (click)="newCart(timeslot)"
          >
            {{ 'checkout.cart.alert.new.confirm' | translate }}
          </button>
        </div>
      </app-modal>
      <app-modal
        #cartIsFullModal
        class="activity-timeslot-list__cart-modal"
        (modalClose)="closeCartIsFullModal()"
      >
        <span modal-header class="activity-timeslot-list__cart-modal__title">
          {{ cartIsFullTextTitle }}
        </span>

        <div modal-content>
          <p>{{ cartIsFullText }}</p>
        </div>
        <div modal-footer class="activity-timeslot-list__cart-modal__footer">
          <button
            class="activity-timeslot-list__cart-modal__footer__confirm"
            app-vtmn-play-button
            type="button"
            [type]="ctaButtonType.Button"
            [variant]="vtmnPlayButtonVariant.SECONDARY"
            [shape]="vtmnPlayButtonShape.SQUARED"
            (click)="closeCartIsFullModal()"
          >
            {{ closeModalText }}
          </button>

          <button
            app-vtmn-play-button
            type="button"
            [type]="ctaButtonType.Button"
            [variant]="vtmnPlayButtonVariant.PRIMARY"
            [shape]="vtmnPlayButtonShape.SQUARED"
            (click)="openCart()"
          >
            {{ goToCartText }}
          </button>
        </div>
      </app-modal>
    </ng-container>
  </ng-container>
</app-activity-timeslot-list>
